export default {
  Dataset: 'مجموعه داده',
  Home: 'خانه',
  Map: 'نما',
  Service: 'سرویس',
  accept: 'تایید',
  access: 'دسترسی',
  'access.apply_filter': 'اعمال فیلتر',
  'access.description': 'فایل مورد نظر را با همکاران خود به اشتراک بگذارید',
  'access.filter.all': 'همه',
  'access.filter.equal': 'برابر',
  'access.filter.less': 'کمتر',
  'access.filter.more': 'بیشتر',
  access_datasets: 'مجموعه‌داده‌ اشتراکی',
  access_maps: 'نمای اشتراکی',
  access_services: 'سرویس اشتراکی',
  reporting: 'گزارش‌گیری',
  active: 'فعال',
  'activity-log': 'گزارش کارکرد',
  add: 'افزودن',
  all: 'همه',
  alphabetical: 'الفبایی',
  apiKey: 'کلید دسترسی',
  cancel: 'انصراف',
  change: 'تغییر',
  'change-language': 'زبان',
  'change-privacy': 'تغییر محرمانگی',
  column: 'ستون',
  columns: 'ستون‌ها',
  comming_soon: 'به زودی',
  connect: 'اتصال',
  'connection.connect': 'اتصال',
  'connection.test': 'تست اتصال',
  copied: 'کپی شد.',
  create: 'ساخت',
  csv: 'csv',
  loading: 'در حال بارگذاری',
  'loading...': 'در حال بارگذاری...',
  id: 'شناسه',
  in_progress: 'In Progress',
  datasets: 'مجموعه داده‌ها',
  datasource: 'منبع داده',
  date: 'تاریخ',
  deactive: '{act}فعال‌سازی',
  de_active: 'غیرفعال',
  drag_drop: 'بکش و رها کن',
  edit: 'ویرایش',

  'data.name': 'نام مجموعه‌داده',
  'data.tags': 'برچسب‌های مجموعه‌داده',
  'data.search': 'عبارت موردنظر را جست‌وجو نمایید',
  'dataset.edit_dataset': 'ویرایش اطلاعات مجموعه‌داده {name}',
  'dataset.enrichment.add_first': 'اولین غنی‌سازی',
  'dataset.enrichment.add_new': 'افزودن غنی‌سازی',
  'dataset.enrichment.consumed': 'مصرف شده',
  'dataset.enrichment.consumption': 'میزان مصرف',
  'dataset.enrichment.coord_format': 'فرمت مختصاتی',
  'dataset.enrichment.create': 'شروع فرآیند',
  'dataset.enrichment.filter_col': 'ستون فیلتر',
  'dataset.enrichment.filter_type': 'نوع فیلتر',
  'dataset.enrichment.full_address': 'آدرس کامل',
  'dataset.enrichment.geom_col': 'ستون جغرافیایی',
  'dataset.enrichment.geom_col_name': 'ستون_ژئومتری',
  'dataset.enrichment.geocode_col_name': 'نتیجه‌ی_ژئوکد',
  'dataset.enrichment.in-use': 'در حال مصرف',
  'dataset.enrichment.inputs': 'ورودی‌ها',
  'dataset.enrichment.lat_col': 'Latitude ستون',
  'dataset.enrichment.lon_col': 'Longitude ستون',
  'dataset.enrichment.out-of-range': 'رکورد خارج ظرفیت',
  'dataset.enrichment.out_col': 'نام ستون خروجی',
  'dataset.enrichment.outputs': 'خروجی‌ها',
  'dataset.enrichment.projection': 'فراتابی',
  'dataset.enrichment.remain': 'باقی‌مانده',
  'dataset.enrichment.rerun': 'اجرای مجدد',
  'dataset.enrichment.schedule': 'زمان‌بندی اجرا',
  'dataset.enrichment.precision': 'تعیین دقت جست‌وجو',
  'dataset.settings.columns.ordering.new_group': 'گروه جدید',

  'edit-data': 'ویرایش داده‌ها',
  'edit-property': 'ویرایش مشخصات',
  'edit.add_layer': '+ افزودن لایه',
  'edit.add_service': '+ افزودن سرویس',
  'edit.add_widget': '+ افزودن ویجت',
  'edit.basemap': 'نقشه‌ی پایه',
  'edit.basemap.raster.google_sattellte': 'ماهواره‌ای گوگل',
  'edit.basemap.raster.google_sattellte_label': 'ماهواره‌ای گوگل با برچسب',
  'edit.basemap.raster.google_terrain': 'ارتفاعی گوگل با برچسب',
  'edit.basemap.raster.google_terrain_traffic': 'ترافیک گوگل',
  'edit.basemap.raster.osm_raster': 'OSM',
  'edit.basemap.raster.map': 'مپ',
  'edit.basemap.raster_source': 'استایل‌های تصویر',
  'edit.basemap.source': 'منبع',
  'edit.basemap.style': 'استایل‌های بردار',
  'edit.basemap.style.Crow': 'کلاغ',
  'edit.basemap.style.Dove': 'کبوتر',
  'edit.basemap.style.Hawk': 'شاهین',
  'edit.basemap.style.Sparrow': 'گنجشک',
  'edit.basemap.style.Swallow': 'پرستو',
  'edit.data.add_column': 'افزودن ستون',
  'edit.data.add_geo_column':
    'با تایپ کردن یک نام جدید، یک ستون با همان نام و تایپ geometry ایجاد می‌شود.',
  'edit.data.add_row': 'افزودن سطر',
  'edit.data.analysis': 'آنالیز',
  'edit.data.create_map': 'ساخت نقشه',
  'edit.data.data': 'دیتا',
  'edit.data.datasource-name-title': 'نام مجموعه‌داده',
  'edit.data.enrichment': 'غنی‌سازی',
  'edit.data.enrichments': 'غنی‌سازی‌ها',
  'edit.data.legend': 'راهنما',
  'edit.data.map_view': 'نمایش روی نقشه',
  'edit.data.metadata': 'متادیتا',
  'edit.data.preview': 'پیش نمایش',
  'edit.data.property': 'ویژگی‌ها',
  'edit.data.save': 'ذخیره',
  'edit.data.select_geom': 'تعیین ستون ژئومتری',
  'edit.data.select_geom_column': 'ستون داده‌ی جغرافیایی جدید',
  'edit.data.select_geom_description':
    'در بارگذاری مجموعه‌داده، اطلاعات ژئومتریک شناسایی نشد. به منظور انجام عملیات‌های آتی، نیازمند تعیین ستون ژئومتری هستید.',
  'edit.data.geom_column_not_set': 'ستون داده‌ی جغرافیایی ایجاد نشده‌ست.',
  'edit.data.start_proccess': 'شروع فرآیند',
  'edit.data.style': 'استایل',
  'edit.data.table_view': 'نمایش جدولی',
  'edit.download': 'دانلود',
  'edit.download.1/1': '۱:۱',
  'edit.download.16/9': '۱۶:۹',
  'edit.download.aspectRatio': 'نسبت تصویر',
  'edit.download.format': 'فرمت خروجی',
  'edit.download.free': 'دلخواه',
  'edit.download.height': 'عرض px',
  'edit.download.width': 'طول px',
  'edit.publish': 'انتشار',
  'edit.publish.access-level': 'تنظیم سطح دسترسی',
  'edit.publish.access-level.create': 'ایجاد',
  'edit.publish.access-level.delete': 'حذف',
  'edit.publish.access-level.edit': 'ویرایش',
  'edit.publish.access-level.read': 'خواندن',
  'edit.publish_config': 'تنظیمات انتشار',
  editor_create_style_not_found: 'آدرس مورد نظر برای ویرایش استایل یافت نشد',
  editor_update_style_not_found: 'آدرس مورد نظر برای ویرایش استایل یافت نشد',
  email: 'ایمیل',
  enrich_type: 'نوع غنی‌سازی',
  'enrichment.done': 'عملیات با موفقیت پایان یافت.',
  'enrichment.failed': 'متاسفانه عملیات لغو شد.',
  'enrichment.select_geo': 'تعیین ژئومتری',
  'enrichment.validation.address': 'ستون آدرس را انتخاب نمایید.',
  'enrichment.validation.export_column_name': 'نام ستون تکراری است.',
  etc: 'غیره',
  favourite: 'موردعلاقه‌ها',
  'filePicker.drop-files-here': 'فایل خود را رها کنید',
  'filePicker.placeholder_with_drag':
    'برای انتخاب فایل کلیک کنید یا فایل را روی صفحه رها کنید',
  'filePicker.placeholder_without_drag': 'برای انتخاب فایل کلیک کنید',
  filter: 'فیلتر',
  filters: 'فیلترها',
  'geo.feature': 'عارضه',
  geojson: 'geojson',
  geography: 'جغرافیایی',
  geom_column: 'ستون جغرافیایی',
  gml: 'gml',
  goBack: 'بازگشت',
  'greetings.actionCall': 'شروع کنیم',
  'greetings.mainMessage': 'سلام{name}، به مپ خوش‌آمدید',
  'greetings.subMessage': 'برای آشنایی با سرویس‌ها برروی دکمه زیر کلیک کنید',
  'grid.cell_menu.add_row': 'اضافه کردن سطر جدید',
  'grid.cell_menu.copy_value': 'کپی مقدار سلول',
  'grid.cell_menu.delete_row': 'حذف سطر',
  'grid.cell_menu.edit-cell': 'ویرایش این سلول',
  'grid.cell_menu.edit-row': 'ویرایش این ردیف',
  'grid.header_menu.add_column': 'اضافه کردن ستون جدید',
  'grid.header_menu.add_alert': 'ایجاد هشدار',
  'grid.header_menu.delete_column': 'حذف ستون',
  'grid.header_menu.edit_feature': 'ویرایش عارضه جغرافیایی',
  'grid.header_menu.edit_name': 'تغییر نام ستون',
  'grid.header_menu.edit_type': 'تغییر نوع دیتا',
  'grid.header_menu.select_geom': 'انتخاب ستون جغرافیایی',
  'grid.loading': 'در حال بارگذاری...',
  'grid.no_data': 'داده‌ای وجود ندارد',
  'grid.header.alert.add.success': 'هشدار با موفقیت ایجاد شد.',
  'grid.header.alert.add.error': 'مشکلی در ایجاد هشدار پیش آمد.',

  'intro.datasets.emptyMessage': 'اولین مجموعه داده خود را بارگزاری کنید',
  'intro.datasets.emptyStatus': 'داده‌ای از قبل موجود نمی‌باشد',
  'intro.datasets.emptySubMessage':
    'برای آشنایی بیشتر با روش‌های بارگزاری داده‌های خود اینجا را کلیک کنید',
  'intro.datasets.error': 'مجموعه داده‌ای پیدا نشد.',
  'intro.datasets.new': 'مجموعه داده‌ی جدید',
  'intro.datasets.select': 'انتخاب مجموعه داده‌',
  'intro.datasets.title': 'مجموعه‌داده‌ها',
  'intro.maps.emptyMessage': 'اولین نقشه خود را بسازید',
  'intro.maps.emptyStatus': 'نقشه‌ای از قبل موجود نمی‌باشد',
  'intro.maps.emptySubMessage':
    'برای آشنایی بیشتر با روش‌های ساخت نقشه اینجا را کلیک کنید',
  'intro.maps.error': 'نمایی پیدا نشد.',
  'intro.maps.new': 'نمای جدید',
  'intro.maps.title': 'نماها',
  'intro.services.emptyMessage': 'اولین سرویس داده خود را انتخاب کنید',
  'intro.services.emptyStatus': 'سرویسی از قبل موجود نمی‌باشد',
  'intro.services.emptySubMessage':
    'برای آشنایی بیشتر با روش‌های انتخاب سرویس اینجا را کلیک کنید',
  'intro.services.error': 'سرویسی پیدا نشد.',
  'intro.services.new': 'سرویس جدید',
  'intro.services.title': 'سرویس‌ها',
  kml: 'kml',
  'layer-asc': 'بیشترین لایه',
  'layer-desc': 'کمترین لایه',
  'layer.default': 'لایه پیش‌فرض',
  'layer.delete': 'حذف لایه',
  'layer.hide': 'پنهان کردن لایه',
  'layer.unhide': 'آشکار کردن لایه',
  layers: 'لایه‌ها',
  limitation: 'محدودیت',
  load_more: 'موارد بیشتر',
  'log.time_interval': 'بازه زمانی',
  'log.time_interval_from': 'از',
  'log.time_interval_last_month': 'ماه گذشته',
  'log.time_interval_last_season': 'فصل گذشته',
  'log.time_interval_last_week': 'هفته گذشته',
  'log.time_interval_last_year': 'سال گذشته',
  'log.time_interval_to': 'تا',
  'log.time_interval_yesterday': 'روز گذشته',
  'login.captcha': 'کد کپچا',
  'login.login': 'وارد شوید!',
  'login.login-title': 'ورود',
  'login.messages.signup.no-account': 'حساب کاربری ندارید؟',
  'login.messages.signup.signup-link': 'ثبت‌نام کنید',
  'login.password': 'رمز عبور',
  'login.password_confirm': 'رمز عبور',
  'login.singin-title': 'ثبت‌نام',
  'login.username': 'نام‌کاربری',
  'login.validate.password':
    'رمز عبور باید بین ۸ تا ۳۰ کاراکتر و شامل اعداد، حروف بزرگ و کوچک انگلیسی و نشانه‌ها باشد',
  'login.validate.username': 'یک ایمیل معتبر وارد نمایید',
  'login.with_otp': 'ورود با رمز یک‌بار مصرف',
  'login.with_otp.enter_code': ' کد ارسال شده به شماره همراهتان را وارد کنید:',
  'login.with_otp.enter_mobile': 'شماره تلفن همراه خود را وارد نمایید:',
  'login.with_otp.recieve_code': 'دریافت کد تایید',
  'login.with_otp.remain_time': 'زمان باقی‌مانده تا انقضای کد:',
  'login.with_otp.resend_code': 'دریافت مجدد کد تایید',
  'login.with_otp.required': 'پر کردن این فیلد الزمی‌ست.',
  'login.with_otp.mobile_min_length':
    'شماره موبایل نمی‌تواند از ۱۱ رقم کمتر باشد',
  'login.with_otp.mobile_not_valid': 'شماره موبایل وارد شده معتبر نمی‌باشد.',
  'login.with_pass': 'ورود با نام کاربری و رمز عبور',
  'management-access': 'دسترسی‌های مدیریت',
  maps: 'نماها',
  mobile: 'تلفن‌همراه',
  my_datasets: 'مجموعه‌داده‌های من',
  my_maps: 'نماهای من',
  my_services: 'سرویس‌های من',
  name: 'نام',
  new: 'جدیدترین',
  no_data: 'داده‌ای موجود نیست.',
  'no-tag': 'بدون برچسب',
  numerical: 'عددی',
  number_of_columns: 'تعداد ستون‌ها',
  number_of_rows: 'تعداد سطرها',
  off: 'خاموش',
  old: 'قدیمی‌ترین',
  on: 'روشن',
  open: '',
  order: 'مرتب‌سازی',
  owner: 'مالک',
  pending: 'در حال ساخت',
  'placeholder.email': 'example@example.com',
  'placeholder.search_dataset':
    'نام مجموعه داده و یا برچسب مورد نظر را جست‌وجو کنید',
  'placeholder.search_service': 'نام سرویس و یا برچسب مورد نظر را جست‌وجو کنید',
  'placeholder.search_view': 'نام نما و یا برچسب مورد نظر را جست‌وجو کنید',
  preview: 'مشاهده',
  private: 'خصوصی',
  'profile.account-types': 'شخصی-سازمانی',
  'profile.account_type_title': 'نوع حساب',
  'profile.add_user': 'افزودن کاربر جدید',
  'profile.admin_password': 'رمز عبور ادمین',
  'profile.cellphone': 'تلفن همراه',
  'profile.change_password': 'تغییر رمز عبور',
  'profile.current_password': 'رمز عبور فعلی',
  'profile.deactive_user': 'آیا از {act}فعال‌سازی کاربر {name} مطمئن هستید؟',
  'profile.deactive_user_warning':
    'کاربر {act}فعال شده، قابل {oact}فعال‌سازی می‌باشد',
  'profile.delete_user': 'آیا از حذف کاربر {name} مطمئن هستید؟',
  'profile.delete_user_warning': 'کاربر حذف شده قابل بازیابی نمی‌باشد',
  'profile.description.message':
    'در حساب کاربری خود می‌توانید نام، تصویر، ایمیل و سایر مشخصات خود را تغییر دهید.',
  'profile.edit_user': 'ویرایش اطلاعات کاربر {name}',
  'profile.exit': 'خروج',
  'profile.firstname': 'نام',
  'profile.lastname': 'نام‌خانوادگی',
  'profile.logout': 'آیا می‌خواهید خارج شوید؟',
  'profile.mail': 'ایمیل',
  'profile.management': 'مدیریت',
  'profile.new_password': 'رمز عبور جدید',
  'profile.notification': 'پیام‌ها',
  'profile.payment': 'پرداخت',
  'profile.private_profile': 'پروفایل خصوصی',
  'profile.profile': 'حساب کاربری',
  'profile.public_profile': 'پروفایل عمومی',
  'profile.re_new_password': 'تکرار رمز عبور جدید',
  'profile.select_language': 'یک زبان را انتخاب نمایید:',
  'profile.settings': 'تنظیمات',
  'profile.user-types': 'کاربر-مدیر',
  'profile.user_type_title': 'نقش',
  'profile.validate.email': 'فرمت ایمیل صحیح نیست',
  'profile.validate.mobile': 'فرمت موبایل صحیح نیست',
  'profile.validate.name': 'لطفا نام کاربر را وارد نمایید',
  'profile.validate.role': 'لطفا نقش  کاربر را انتخاب نمایید',
  public: 'عمومی',
  record: 'رکورد',
  regional_search: 'جست‌وجو محدوده‌ای',
  regionalsearch: 'جست‌وجو محدوده‌ای',
  'regional_search.desc': 'جست‌وجوی جغرافیایی بر محدوده انتخاب شده یا رسم شده',
  remove: 'حذف',
  restart: 'تازه‌کردن',
  results: 'نتایج',
  role: 'نقش',
  row: 'سطر',
  rows: 'سطرها',
  'rows-asc': 'بیشترین رکورد',
  'rows-desc': 'کمترین رکورد',
  save: 'ذخیره',
  search: 'جست‌وجو',
  'search.desc': 'جست‌وجو بر اساس مجموعه‌داده انتخابی',
  'search.nearest': 'جست‌وجوی نزدیک‌ترین فاصله',
  select_datasource: 'انتخاب مجموعه‌داده',
  select_service: 'انتخاب سرویس',
  select_widget: 'انتخاب ویجت',
  send: 'ارسال',

  'datasource.add.upload.dopzone.title_accept': 'فرمت فایل شما قابل قبول است.',
  'datasource.add.upload.dopzone.title_reject': 'فرمت فایل شما تشخیص داده نشد.',
  'datasource.add.upload.dopzone.title_idle':
    'فایل خود را اینجا رها کرده یا برای انتخاب کلیک کنید.',
  'datasource.add.upload.dopzone.subtitle':
    'فرمت‌های پشتیبانی شده: KML, GML, GEOJSON, JSON, ZIP, CSV, XSLX, JP2',

  'service.create': 'ساخت سرویس',
  'service.create_empty_view': 'ساخت نمای خالی',
  'service.create_with_view': 'ساخت نما',
  'service.create_with_widget_view': 'ساخت نما با ویجت‌',
  'service.description': 'توضیحات سرویس',
  'service.details': 'جزئیات سرویس',
  'service.name': 'نام سرویس',
  'service.restart': 'تازه‌کردن',
  'service.select_service_properties': 'مشخصات سرویس را وارد نمایید:',
  'service.select_service_type': 'لطفا یکی از سرویس‌ها را انتخاب نمایید:',
  'service.select_view_widget':
    'با انتخاب سرویس‌های زیر، می‌توانید نمایی با ویجت این سرویس‌ها بسازید:',
  'service.tags': 'برچسب‌های سرویس',
  'service.update': 'ویرایش سرویس',
  'service.validation.filterable': 'لطفا فیلترهای سرویس را انتخاب نمایید.',
  'service.validation.geom_column': 'لطفا ستون جغرافیایی را انتخاب نمایید.',
  'service.validation.name': 'لطفا نام سرویس را وارد نمایید.',
  'service.validation.searchfield':
    'لطفا ستون جست‌وجوی سرویس را انتخاب نمایید.',
  'service.validation.selectable': 'لطفا ستون‌های سرویس را انتخاب نمایید.',
  service_type: 'نوع سرویس',
  services: 'سرویس‌ها',
  settings: 'تنظیمات',
  shapefile: 'shapefile',
  share: 'اشتراک‌گذاری',
  'share.link': 'عمومی',
  'share.link_deactive': 'لینک غیرفعال',
  'share.link_warning': 'دیگران هم قادر به مشاهده این لینک هستند.',
  'share.private': 'خصوصی',
  'share.private_warning': 'فقط شما قادر به مشاهده این لینک هستید.',
  'share.access_to_map': 'دسترسی به این نقشه',
  'share.copy_link': 'کپی کردن لینک عمومی',
  'share.open_in_new_tab': 'باز کردن در تب جدید',
  'share.iframe': 'کد آی‌فریم',
  'share.copy_iframe': 'کپی کردن کد آی‌فریم',
  'share.desc': 'جهت نمایش نقشه، کد بالا را کپی و در صفحه‌ی مربوطه قرار دهید.',
  'show-all': 'نمایش همه',
  'sidebar.dataset_settings.button.copy_dataset': 'کپی‌کردن مجموعه‌داده',
  'sidebar.dataset_settings.button.lock_dataset': 'قفل مجموعه‌داده',
  'sidebar.dataset_settings.input.attributes_placeholder':
    'ویژگی‌های داده را وارد کنید',
  'sidebar.dataset_settings.input.description_placeholder':
    'تمامی راه‌ها و امکان تفریحی، رفاهی و تاریخی شهر قزوین در محدوده ۲۰ کیلومتری',
  'sidebar.dataset_settings.input.name_placeholder': 'نقشه قزوین',
  'sidebar.dataset_settings.input.source_placeholder': 'منبع داده را وارد کنید',
  'sidebar.dataset_settings.input.tags_placeholder': 'قزوین،اماکن،تاریخی',
  'sidebar.view_settings.add_operation': 'افزودن عملگرها',
  'sidebar.view_settings.layer_management': 'لایه‌های نقشه',
  'sidebar.view_settings.layer_management.legend': 'راهنمای نقشه',
  'sidebar.view_settings.layer_management.open_by_default': 'باز بودن پیش‌فرض',
  'sidebar.view_settings.switch.isRTL': 'راست چین بودن',
  'sidebar.view_settings.checkbox.compass': 'جهت‌گیری (قطب‌نما)',
  'sidebar.view_settings.checkbox.go_coord': 'رفتن به مختصات',
  'sidebar.view_settings.checkbox.layer_management': 'انتخاب‌کننده لایه‌ها',
  'sidebar.view_settings.checkbox.my_location': 'موقعیت من',
  'sidebar.view_settings.checkbox.print': 'چاپ‌گر',
  'sidebar.view_settings.checkbox.public_search': 'جست‌وجوی عمومی',
  'sidebar.view_settings.checkbox.show_compass': 'نمایش جهت‌گیری (قطب‌نما)',
  'sidebar.view_settings.checkbox.show_coord': 'نمایش مختصات نشان‌گر',
  'sidebar.view_settings.checkbox.show_current_location': 'نمایش موقعیت جاری',
  'sidebar.view_settings.checkbox.show_go_coord': 'نمایش رفتن به مختصات',
  'sidebar.view_settings.checkbox.show_layer_management':
    'نمایش انتخاب‌کننده لایه‌ها',
  'sidebar.view_settings.checkbox.show_my_location': 'نمایش موقعیت من',
  'sidebar.view_settings.checkbox.show_print': 'نمایش چاپ‌گر',
  'sidebar.view_settings.checkbox.show_public_search': 'نمایش جست‌وجوی عمومی',
  'sidebar.view_settings.checkbox.show_legend': 'نمایش راهنمای نقشه',
  'sidebar.view_settings.checkbox.show_scale': 'نمایش مقیاس (عددی و خطی)',
  'sidebar.view_settings.checkbox.show_tool_bar': 'نمایش نوار ابزار',
  'sidebar.view_settings.checkbox.show_zoom': 'نمایش زوم',
  'sidebar.view_settings.checkbox.show_measurement': 'نمایش اندازه‌گیری',
  'sidebar.view_settings.display_options': 'تنظیمات نمایشی',
  'sidebar.view_settings.input.initial_zoom_level': 'بزرگنمایی اولیه',
  'sidebar.view_settings.input.initial_zoom_level_placeholder':
    'پیش‌فرض سطح ۱۰',
  'sidebar.view_settings.input.tags': 'برچسب‌های نما',
  'sidebar.view_settings.input.tags_placeholder': 'قزوین،اماکن،تاریخی',
  size: 'اندازه',
  'size-asc': 'بیشترین حجم',
  'size-desc': 'کمترین حجم',
  status: 'وضعیت',
  'step.next': 'مرحله بعد',
  'style_editor.create_new_style': 'ساخت استایل',
  'style_editor.update_style': 'تغییر استایل',
  'subview.dataset-add.add_empty_dataset': 'ساخت مجموعه‌داده خالی',
  'subview.dataset-add.file-dir-url': 'آدرس فایل یا دایرکتوری',
  'subview.dataset-add.input.database_name': 'Databse Name',
  'subview.dataset-add.input.driver': 'Driver',
  'subview.dataset-add.input.host': 'Host',
  'subview.dataset-add.input.password': 'Password',
  'subview.dataset-add.input.port': 'Port',
  'subview.dataset-add.input.table_name': 'Table Name',
  'subview.dataset-add.input.username': 'Username',
  'subview.dataset-add.subtitle':
    'با استفاده از روش‌های مختلف نقشه خود را بسازید و روی آن آنالیز انجام دهید.',
  'subview.dataset-add.tab.log': 'گزارش‌ها',
  'subview.dataset-add.tab.use_available_datasourses':
    'استفاده از مجموعه‌داده‌های موجود',
  'subview.dataset-add.tab.use_cloud': 'انتخاب از فضای ابری',
  'subview.dataset-add.tab.use_data-service':
    'اتصال به سرویس‌های داده‌ای بیرونی',
  'subview.dataset-add.tab.use_databse': 'اتصال به بانک اطلاعاتی بیرونی',
  'subview.dataset-add.tab.use_file': 'بارگذاری',
  'subview.dataset-add.title': 'ساخت مجموعه داده‌ی جدید',
  'subview.dataset-add.upload-local-files': 'بارگذاری فایل محلی',
  'subview.dataset.enrichment': 'غنی‌سازی جدید',
  'subview.services-add': 'ساخت سرویس جدید از دیتاست {datasourceName}',
  'subview.services-add.subtitle': 'سرویس خود را بسازید.',
  'subview.services-add_layer': 'افزودن لایه به نقشه',
  'subview.services-add_layer.subtitle':
    'می‌توانید از سرویس‌های زیر، لایه به نقشه خود اضافه کنید.',
  'subview.services-add_new': 'ساخت سرویس جدید',
  'subview.services-add_new.subtitle': 'سرویس خود را بسازید.',
  'subview.services-add_widget': 'افزودن ویجت به نقشه',
  'subview.services-add_widget.subtitle':
    'می‌توانید از سرویس‌های زیر، ویجت به نقشه خود اضافه کنید.',
  'subview.services-edit': 'ویرایش سرویس {serviceName}',
  'subview.services-edit.subtitle': 'سرویس خود را ویرایش کنید.',
  'subview.services-edit.datasource': 'منبع داده: ',
  'table.activity': 'فعالیت',
  'table.optionMenu.name': 'عملیات',
  'table.section': 'بخش',
  'table.status': 'وضعیت',
  'table.time': 'زمان',
  'table.upload_date': 'تاریخ بارگذاری',
  tags: 'برچسب‌ها',
  text: 'متنی',
  tiles: 'کاشی نقشه (وکتور)',
  'tiles.desc': 'نمایش مجموعه‌داده انتخابی روی نقشه',
  'toaster.default.redirect_to_login': 'به صفحه ورود منتفل می‌شوید.',
  'toaster.error.create_new_service':
    'روند ساخت سرویس، آغاز شد و تا دقایقی دیگر به اتمام می‌رسد. شکیبا باشید...',
  'toaster.error.datasource_not_selected':
    'لطفا ابتدا یک مجموعه‌داده انتخاب نمایید!',
  'toaster.error.editor_add_widget/layer_to_view': 'لایه/ویجت به نما اضافه شد!',
  'toaster.error.editor_autocomplete_not_found': 'موردی یافت نشد!',
  'toaster.error.editor_get_column_not_found':
    'ستونی برای این مجموعه‌داده یافت نشد!',
  'toaster.error.editor_get_datasource_not_found': 'این مجموعه‌داده یافت نشد!',
  'toaster.error.editor_get_nearest_not_found': 'نزدیک‌ترین یافت نشد!',
  'toaster.error.editor_get_row_not_found':
    'سطری برای این مجموعه‌داده یافت نشد!',
  'toaster.error.editor_get_search_params_not_found':
    'ستون‌های جست‌وجو یافت نشد!',
  'toaster.error.editor_get_service_not_found': 'سرویسی یافت نشد!',
  'toaster.error.editor_get_table_not_found':
    'جدولی برای این مجموعه‌داده یافت نشد!',
  'toaster.error.editor_get_user_not_found': 'کاربر یافت نشد!',
  'toaster.error.editor_get_view_not_found': 'نمایی یافت نشد!',
  'toaster.error.editor_identify_not_found': 'اطلاعات یافت نشد!',
  'toaster.error.editor_widget/layer_not_found': 'لایه/ویجت یافت نشد!',
  'toaster.error.enrich_type_not_selected':
    'لطفا ابتدا نوع غنی‌سازی را انتخاب نمایید!',
  'toaster.error.loagin_failed.captcha': 'ثابت کنید که ربات نیستید!',
  'toaster.error.login_failed': 'مشکلی پیش آمده. دوباره تلاش کنید.',
  'toaster.error.login_failed.email_not_found':
    'کاربری با این مشخصات یافت نشد.',
  'toaster.error.login_failed.password_not_correct':
    'رمز عبور وارد شده اشتباه است.',
  'toaster.error.my_location_error': 'یافتن موقعیت مکانی شما با خطا مواجه شد.',
  'toaster.error.my_location_not_supported':
    'مرورگر شما، نمایش موقعیت را پشتیبانی ‌نمی‌کند.',
  'toaster.error.profile.change_password': 'تکرار رمز عبور جدید صحیح نیست!',
  'toaster.error.send_code': 'ارسال کد با مشکل مواجه شد؛ دوباره تلاش کنید.',
  'toaster.error.service_cant_update': 'به‌روزرسانی سرویس با مشکل مواجه شد.',
  'toaster.error.service_not_selected': 'لطفا ابتدا یک سرویس انتخاب نمایید!',
  'toaster.error.service_type_not_selected':
    'لطفا ابتدا نوع سرویس را انتخاب نمایید!',
  'toaster.error.users_conflict': 'ایمیل یا موبایل قبلا ثبت شده است!',
  'toaster.error.wrong_code': 'کد وارد شده صحیح نیست.',
  'toaster.error.enrichment_removed': 'حذف غنی‌سازی با خطا مواجه شد.',
  'toaster.error.enrichment_started_again':
    'اجرای مجدد غنی‌سازی با خطا مواجه شد.',
  'toaster.error.db_connection_error': 'اتصال به دیتابیس ناموفق بود.',
  'toaster.error.creating_enrichment': 'ساخت غنی‌سازی با خطا مواجه شد.',
  'toaster.success.profile.add_new_user': 'کاربر جدید با موفقیت افزوده شد!',
  'toaster.success.profile.change_password': 'رمز عبور با موفقیت تغییر یافت!',
  'toaster.success.profile.delete_user': 'کاربر با موفقیت حذف شد!',
  'toaster.success.service_updated': 'سرویس با موفقیت به‌روزرسانی شد.',
  'toaster.success.shared': 'با موفقیت به اشتراک گذاشته شد.',
  'toaster.success.updated': 'با موفقیت به‌روزرسانی شد.',
  'toaster.success.thumbnail_changed': 'تصویر به عنوان نمایه انتخاب شد.',
  'toaster.success.enrichment_removed': 'غنی‌سازی با موفقیت حذف شد.',
  'toaster.success.enrichment_started_again': 'غنی‌سازی مجددا شروع شد.',
  'toaster.success.db_connection_started':
    'عملیات اتصال به دیتابیس آغاز شد. لطفا شکیبا باشید...',
  'toaster.success.connection_test': 'تست اتصال موفقیت آمیز بود.',
  'toaster.update.uploading': 'در حال بارگذاری',
  'toaster.update.upload_successful': 'فایل با موفقیت آپلود شد',
  'toaster.update.upload_failed': 'آپلود ناموفق بود',
  'toaster.warning.invalid_coordinates': 'مقدار معتبر نیست.',
  'toaster.warning.creating_tiles':
    'برای استایل‌دهی، تا پایان ساخت سرویس کاشی نقشه شکیبا باشید...',
  updated: 'به‌روزشده',
  user: 'کاربر',
  'user-management': 'مدیریت کاربران',
  'view.description': 'توضیحات',
  'view.name': 'نام نما',
  'view.no_decription': 'بدون توضیحات',
  'view.decription': 'توضیحات',
  'view.no_name': 'بی‌نام',
  'view.tiles.identify.attributes.not_found': 'اطلاعاتی یافت نشد.',
  'view.tiles.identify.attachment.not_found': 'پیوستی یافت نشد.',
  'view.service.add_select_datasource':
    'می‌توانید یک مجموعه‌داده بارگذاری نمایید یا از بین مجموعه‌داده‌های موجود یکی را انتخاب نمایید:',
  'view.service.add_subtitle':
    'می‌توانید از سرویس‌های زیر، ویجت به نقشه خود اضافه کنید.',
  'view.service.add_title': 'افزودن ویجت به نقشه',
  'view.service.add_widget_to_view': 'اضافه کردن به نما',
  'view.service.select_view_widget':
    'با انتخاب سرویس‌های زیر می‌توانید ویجت آن‌ها را به نما اضافه نمایید:',
  'view.tag': 'برچسب(با ، بدون فاصله)',
  'view.thumbnail': 'نمایه',

  'widget.delete': 'حذف ویجت',
  'widget.hide': 'پنهان کردن ویجت',
  'widget.reg-search.geo-filter-result': 'عوارض موجود',
  'widget.reg-search.option.draw-region': 'رسم محدوده',
  'widget.reg-search.option.select-region': 'انتخاب از نقشه',
  'widget.reg-search.settings.buffer_radius': 'حاشیه (متر)',
  'widget.reg-search.settings.buffer_radius.info':
    'میزان حاشیه هنگام جست‌وجوی عارضه‌های نزدیک از دیتاست‌های انتخاب شده.',
  'widget.reg-search.change-zone': 'محدوده‌ی جست‌وجو را تغییر دهید',
  'widget.reg-search.title': 'تنظیمات محدوده',
  'widget.reg-search.tooltip.buffer-side-both': 'بافر مشترک',
  'widget.reg-search.tooltip.buffer-side-in': 'بافر داخلی',
  'widget.reg-search.tooltip.buffer-side-out': 'بافر خارجی',
  'widget.reg-search.tooltip.buffer-zone-diff': 'ناحیه بافر',
  'widget.reg-search.tooltip.buffer-zone-in': 'ناحیه داخلی',
  'widget.reg-search.tooltip.buffer-zone-out': 'ناحیه خارجی',
  'widget.search.filter-query-placeholder': 'محتوی فیلتر',
  'widget.search.intro': 'جست‌وجو در مجوعه‌داده',
  'widget.search.no-result-messge': 'متاسفانه نتیجه‌ای پیدا نشد.',
  'widget.search.no-result-submessge': '',
  'widget.search.similar_phrase': 'عبارات مشابه را جست‌وجو کنید',
  'widget.search.check_again': 'پارامتر‌ها و فیلتر‌ها را دوباره بررسی کنید',
  'widget.search.searchfield': 'ستون جست‌وجو',
  'widget.search.show_nearest': 'نمایش نزدیک‌ترین فاصله',
  'widget.search.show_nearest_air': 'نمایش نزدیک‌ترین فاصله هوایی',
  'widget.search.show_nearest_route': 'نمایش نزدیک‌ترین فاصله زمینی',
  'widget.unhide': 'آشکار کردن ویجت',

  'layer.type': 'نوع لایه',
  'layer.type.fill': 'محدوده',
  'layer.type.line': 'خط',
  'layer.type.circle': 'نقطه',
  'layer.type.symbol': 'آیکون/متن',

  widgets: 'ویجت‌ها',
  xlsx: 'xlsx',
  'scroll-to-top': 'برو بالا',

  'widgets.create.widget_name': 'نام ویجت',
  'widgets.create.type.chart': 'ویجت‌های تحلیلی',
  'widgets.create.type.field_aggregation': 'ویجت‌های آماری',
  'widgets.create.type.chart.bar': 'نمودار میله‌ای',
  'widgets.create.type.chart.line': 'نمودار خطی',
  'widgets.create.type.chart.pie': 'نمودار دایره‌ای',
  'widgets.create.type.field_aggregation.text': 'نمایش مقدار',
  'widgets.toast.create.success': 'ویجت با موفقیت ساخته شد.',
  'widgets.toast.create.error': 'در ایجاد ویجت مشکلی به‌وجود آمد.',
  'widgets.toast.add.success': 'ویجت با موفقیت به نما اضافه شد.',
  'widgets.toast.add.error': 'در اتصال ویجت به نما مشکلی به‌وجود آمد.',

  'widgets.chart.bar.settings.brush': 'نمایش زوم',
};
